<template>
  <section class="content">
    <!-- Default box -->
    <div
      class="card card-solid"
      :style="{ 'min-height': $store.state.screenHeight - 200 + 'px' }"
    >
      <div class="card-body">
        <div class="card-body pt-0">
          <div class="card-header pb-0 pl-0 pr-0">
            <div class="row" style="margin-right:0; margin-left:0;">
              <div class="form-group row col-sm-2 pb-0">
                <label
                  for="date"
                  class="col-sm-4 col-form-label text-right pb-0"
                  >เลือกสาขา</label
                >
                <div class="col-sm-8 pb-0">
                  <select
                    class="custom-select mr-sm-2 pb-0"
                    id="Host"
                    v-model="branch"
                  >
                    <option
                      v-for="(b, i) in $store.state.branch_list"
                      :key="'branch' + i"
                      :value="b"
                      >{{ b.branch_name }}</option
                    >
                  </select>
                </div>
              </div>

              <div class="form-group row col-sm-2 pb-0">
                <label for="date" class="col-sm-4 col-form-label text-right"
                  >จากวันที่</label
                >
                <div class="col-sm-8">
                  <a-date-picker
                    v-model="startDate"
                    :format="'DD/MM/YYYY'"
                    style="width: 100%;"
                    :disabledDate="selectDateStart"
                  />
                </div>
              </div>
              <div class="form-group row col-sm-2 pb-0">
                <label for="date" class="col-sm-4 col-form-label text-right"
                  >ถึงวันที่</label
                >
                <div class="col-sm-8">
                  <a-date-picker
                    v-model="endDate"
                    :format="'DD/MM/YYYY'"
                    style="width: 100%;"
                    :disabledDate="selectDateEnd"
                  />
                </div>
              </div>
              <div class="form-group row col-sm-2 pb-0">
                <div class="col-sm-8">
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="getReport"
                  >
                    <i class="fas fa-search"></i>&nbsp;ค้นหา
                  </button>
                </div>
              </div>
              <div class="form-group row col-sm-2 pb-0">
                &nbsp;
              </div>
              <div class="form-group row col-sm-2 pb-0 justify-r">
                <button
                  type="button"
                  class="btn btn-success"
                  @click="modal_active = true; isEdit = false; id=''; number_unit=0.00; editDate = moment(new Date()); stockAmount=0.00;"
                >
                  <i class="fas fa-plus-circle"></i>&nbsp;เพิ่มข้อมูล
                </button>
              </div>
            </div>
          </div>

          <a-modal
            :title="modal_title"
            centered
            v-model="modal_active"
            @ok="modal_ok"
            @cancel="modal_cancel"
          >
            <div class="form-group row mb-1 ml-0 mr-0">
              <label
                for="vendor_name"
                class="col-sm-1 text-right col-form-label"
                >เลือกสาขา</label
              >
              <div class="col-sm-3">
                <select
                  class="custom-select mr-sm-2 pb-0"
                  id="Host"
                  v-model="branchInsert"
                  :disabled="isEdit"
                >
                  <option
                    v-for="(bx, ix) in $store.state.branch_list"
                    :key="'branch' + ix"
                    :value="bx"
                    >{{ bx.branch_name }}</option
                  >
                </select>
              </div>
            </div>
            <div class="form-group row mb-1">
              <label
                for="vendor_name"
                class="col-sm-1 text-right col-form-label"
                >วันที่</label
              >
              <div class="col-sm-3">
                <a-date-picker
                  :disabled="isEdit"
                  v-model="editDate"
                  :format="'DD/MM/YYYY'"
                  style="width: 100%;"
                  :disabledDate="disabledDate"
                />
              </div>
            </div>
            <div class="form-group row mb-1">
              <table class="table mb-0 mr-4 ml-4">
                <tbody>
                  <tr class="thead-dark text-center trTop">
                    <th class="text-center trTop" style="width:5%">#</th>
                    <th class="text-left trTop" style="width:10%">
                      รหัสสินค้า
                    </th>
                    <th class="text-left trTop">ชื่อสินค้า</th>
                    <th class="text-right trTop">หมวดหมู่</th>
                    <th class="text-right trTop">จำนวนสินค้าคงเหลือ</th>
                    <th
                      class="text-right trTop"
                      style="width:15%;"
                    >
                      นับได้
                    </th>
                    <th class="text-right trTop"></th>
                  </tr>
                  <tr>
                    <td class="text-center">1</td>
                    <td class="text-left">
                      6999
                    </td>
                    <td class="text-left">
                      ข้าวเหนียวนึ่ง
                    </td>
                    <td class="text-right">
                      ข้าวเหนียว
                    </td>
                    <td class="text-right">
                      {{amountShow()}}
                    </td>
                    <td class="text-right">
                      <input
                        type="text"
                        class="form-control text-right"
                        style="font-size:14px"
                        id="number_unit"
                        placeholder="0"
                        maxlength="7"
                        v-model.number="number_units"
                        v-on:keypress="NumbersOnly"
                      />
                    </td>
                    <td class="text-left">
                      กิโลกรัม
                    </td>
                  </tr>
                  <tr>
                    <td class="text-left"></td>
                    <td class="text-left">
                      &nbsp;
                    </td>
                    <td class="text-right"></td>
                    <td class="text-right"></td>
                    <td class="text-right"></td>
                  </tr>
                  <tr>
                    <td class="text-left"></td>
                    <td class="text-left">
                      &nbsp;
                    </td>
                    <td class="text-right"></td>
                    <td class="text-right"></td>
                    <td class="text-right"></td>
                  </tr>
                  <tr>
                    <td class="text-left"></td>
                    <td class="text-left">
                      &nbsp;
                    </td>
                    <td class="text-right"></td>
                    <td class="text-right"></td>
                    <td class="text-right"></td>
                  </tr>
                  <tr>
                    <td class="text-left"></td>
                    <td class="text-left">
                      &nbsp;
                    </td>
                    <td class="text-right"></td>
                    <td class="text-right"></td>
                    <td class="text-right"></td>
                  </tr>
                  <tr>
                    <td class="text-left"></td>
                    <td class="text-left">
                      &nbsp;
                    </td>
                    <td class="text-right"></td>
                    <td class="text-right"></td>
                    <td class="text-right"></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="form-group row mb-1">
              <label
                for="vendor_name"
                class="col-sm-1 text-right col-form-label"
                >หมายเหตุ</label
              >
              <div class="col-sm-11">
                <textarea class="form-control" rows="3"   v-model="description"></textarea>
              </div>
            </div>
          </a-modal>

          <div class="text-center pt-3" v-if="report_data.length < 1">
            <h5>ไม่มีข้อมูล</h5>
          </div>
          <div class="table-responsive-sm mt-3" v-if="report_data.length > 0">
            <div
              class="table-responsive-sm mt-3"

            >
              <div>
                <table class="table mb-0">
                  <tbody>
                    <tr class="thead-dark text-center trTop">
                      <th class="text-center trTop" style="width:10%">#</th>
                      <th class="text-left trTop">สาขา</th>
                      <th class="text-left trTop" style="width:10%">วันที่</th>
                      <th class="text-left trTop" style="width:10%">เวลา</th>
                      <th class="text-center trTop">
                        ตัวเลือก
                      </th>
                    </tr>
                    <tr
                    v-for="(c, i) in report_data"
                    :key="'c' + i">
                      <td class="text-center">#</td>
                      <td class="text-left">
                        {{ c.branchName }}
                      </td>
                      <td class="text-left">
                        {{ c.stockDate }}
                      </td>
                      <td class="text-left">
                        {{ c.stockTime }}
                      </td>
                      <td class="text-center">
                        <button
                          type="button"
                          class="btn btn-warning"
                          @click="modal_active=true; isEdit=true; editData(c)"
                        >
                          <i class="fas fa-edit"></i>&nbsp;แก้ไขข้อมูล
                        </button>
                        <!-- <button
                          type="button"
                          class="btn btn-danger"
                          @click="removeData(c.id)"
                        >
                          <i class="fas fa-trash"></i>&nbsp;ลบข้อมูล
                        </button> -->
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
/* eslint-disable */
import moment from "moment";
import apiCenterV2 from "../services/service_undefined_v2";
import Swal from 'sweetalert2'

export default {
  data() {
    return {
      riceKilo: 0.0,
      riceKasob: 45,
      tab: 0,
      report_data: [],
      startDate: moment(new Date()),
      data_edit: {},
      data_edit_pay: {},
      endDate: moment(new Date()),
      editDate: moment(new Date()),
      header: {
        headers: {
          "Access-Token": sessionStorage.token
        }
      },
      form_data: "",
      branch: 0,
      branchId: "",
      branchName: "",
      host_list: [],
      host: null,
      data_cus_list: [],
      begin_code: "",
      end_code: "",
      dyn_address: "",
      modal_active: false,
      modal_title: "นับสต๊อกสินค้า",
      number_unit: 0.0,
      data_branch: [],
      branchInsert: 0,
      isEdit:false,
      id:"",
      stockAmount:0.00,
      description:""
    };
  },
  computed: {
    number_units: {
      get: function() {
        if (this.number_unit !== "")
          return parseFloat(this.number_unit).toFixed(2);
        else return parseFloat(0).toFixed(2);
      },
      set: function(newValue) {
        this.number_unit = newValue;
      }
    },
    riceKilos: {
      get: function() {
        if (this.riceKilo !== "") return parseFloat(this.riceKilo).toFixed(2);
        else return parseFloat(0).toFixed(2);
      },
      set: function(newValue) {
        this.riceKilo = newValue;
      }
    },
    riceKasobs: {
      get: function() {
        if (this.riceKasob !== "") return parseFloat(this.riceKasob).toFixed(2);
        else return parseFloat(0).toFixed(2);
      },
      set: function(newValue) {
        this.riceKasob = newValue;
      }
    }
  },
  methods: {
    modal_ok() {
      if (this.id == "") {
        //console.log(this.editDate)
        this.saveRemainStock();
      } else {
        this.updateRemainStock();
      }
    },
    modal_cancel() {},
    changeFormatDate(dateValue) {
      return dateValue
        .replace("T", " ")
        .replace(".000Z", "")
        .replaceAll("-", "/");
    },
    NumbersOnly(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    getReport() {
      if (this.branch.branch_name != undefined) {
        this.$store.commit("Loading");
        apiCenterV2.selectRemainStock(
          {
            startDate: moment(this.startDate).format("yyyyMMDD"),
            endDate: moment(this.endDate).format("yyyyMMDD"),
            branchName: this.branch.branch_name.substring(
              4,
              this.branch.branch_name.length
            )
          },
          this.header,
          results => {
            if (results.data.isStatus && results.data.data) {
              this.report_data = results.data.data;
              console.log(this.report_data)
            }
            this.$store.commit("Loading");
          },
          errors => {
            this.$store.commit("Loading");
            this.$notification["warning"]({
              message: "ไม่สามารถเข้าถึงข้อมูลได้",
              description: errors.data.message
            });
          }
        );
      }
    },
    updateRemainStock() {
      this.$store.commit("Loading");
      apiCenterV2.updateRemainStock(
        {
          id: this.id,
          branchName: this.branch.branch_name.substring(
              4,
              this.branch.branch_name.length
            ),
          amount: this.number_unit,
          description: this.description
        },
        this.header,
        results => {
          if (results.data.isStatus) {
            this.getReport();
            this.$notification["success"]({
              message: "บันทึกสำเร็จ",
              description: results.data.message
            });
          }
          this.$store.commit("Loading");
        },
        errors => {
          this.$store.commit("Loading");
          this.$notification["warning"]({
            message: "บันทึกไม่สำเร็จ",
            description: errors.data.message
          });
        }
      );
    },
    selectSettingRice() {
      this.$store.commit("Loading");
      apiCenterV2.selectSettingRice(
        this.header,
        results => {
          if (results.data.isStatus && results.data.data.length > 0) {
            this.riceKilo = results.data.data[0].riceKilo;
          }
          this.$store.commit("Loading");
        },
        errors => {
          console.log(errors);
          this.$store.commit("Loading");
          this.$notification["warning"]({
            message: "ไม่สามารถดึงข้อมูลจากระบบได้",
            description: errors.data.message
          });
        }
      );
    },
    saveRemainStock () {
      const dataUser = JSON.parse(sessionStorage.user);
      this.$store.commit("Loading");
      apiCenterV2.saveRemainStock(
        {
          branchName: this.branch.branch_name.substring(
              4,
              this.branch.branch_name.length
            ),
          amount: this.number_unit,
          description: this.description,
          stockDate: this.editDate,
          stock_qty: 0,
          createdBy: dataUser.role_name
        },
        this.header,
        results => {
          if (results.data.isStatus) {
            this.$notification["success"]({
              message: "บันทึกสำเร็จ",
              description: results.data.message
            });
            this.getReport();
            this.modal_active = false;
          } else {
            this.$notification["warning"]({
              message: "บันทึกไม่สำเร็จ",
              description: results.data.message
            });
          }
          this.$store.commit("Loading");
        },
        errors => {
          this.$store.commit("Loading");
          this.$notification["warning"]({
            message: "บันทึกไม่สำเร็จ",
            description: errors.data.message
          });
        }
      );
    },
    editData (dataValues) {
      this.editDate = dataValues.sDate;
      this.id = dataValues.id;
      this.number_unit = dataValues.amount;
      this.stockAmount = dataValues.stock_qty;
      console.log(dataValues)
    },
    removeData(valueId) {
      Swal.fire({
        title: 'ลบข้อมูลสต๊อก',
        text: 'ท่านต้องการลบข้อมูลสต๊อก ใช่หรือไม่ ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.$store.commit("Loading");
          apiCenterV2.deleteRemainStock(
            {
              branchName: this.branch.branch_name.substring(
                  4,
                  this.branch.branch_name.length
                ),
              id: valueId
            },
            this.header,
            results => {
              if (results.data.isStatus) {
                this.$notification["success"]({
                  message: "บันทึกสำเร็จ",
                  description: results.data.message
                });
                this.getReport();
              } else {
                this.$notification["warning"]({
                  message: "บันทึกไม่สำเร็จ",
                  description: results.data.message
                });
              }
              this.$store.commit("Loading");
            },
            errors => {
              this.$store.commit("Loading");
              this.$notification["warning"]({
                message: "บันทึกไม่สำเร็จ",
                description: errors.data.message
              });
            }
          );
        }
      })
    },
    disabledDate(current) {
      // Can not select days before today and today
      return current && current.valueOf() > Date.now();
    },
    selectDateStart(current) {
      return current && current.valueOf() > this.endDate;
    },
    selectDateEnd(current) {
      return current && current.valueOf() < this.startDate;
    },
    amountShow() {
      if(this.isEdit)
        return this.numberFormatDecimal(this.stockAmount);
      else
        return this.numberFormatDecimal(0)
    }
  },
  mounted() {
    this.getBranch();
    this.selectSettingRice();
    setTimeout(() => {
      this.branch = this.$store.state.branch_list[0];
      this.branchInsert = this.$store.state.branch_list[0];
      this.branchId = this.$store.state.branch_list[0].id;
      this.branchName = this.$store.state.branch_list[0].branch_name;
      this.dyn_address = this.$store.state.branch_list[0].dyn_address;
      this.getReport();
    }, 500);
  }
};
</script>

<style>
.trTop {
  background-color: #353a40 !important;
}

.trMid {
  color: black !important;
  background-color: #d6d6d6 !important;
}

.trBot {
  color: black !important;
  background-color: #fefac0 !important;
}

.tdtextColor {
  color: #ff2f1c !important;
}
.custom-select {
  font-size: 14px;
  height: calc(1.9rem + 2px);
}
.btn {
  font-size: 14px;
}

.justify-r {
  justify-content: right;
}

.row {
  margin-left: 0px;
  margin-right: 0px;
}

.ant-modal-body {
  padding: 24px 0px;
}

.ant-modal {
  width: 1024px !important;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/stk_amount.vue